var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38312",
    "data-name": "Group 38312",
    transform: "translate(-311 -385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7679",
    "data-name": "Rectangle 7679",
    width: 31,
    height: 31,
    rx: 5,
    transform: "translate(311 385)",
    fill: "#c7b9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38311",
    "data-name": "Group 38311",
    transform: "translate(318 392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65505",
    "data-name": "Path 65505",
    d: "M9.283,1a8.283,8.283,0,1,0,8.283,8.283A8.291,8.291,0,0,0,9.283,1Zm3.223,8.7L7.533,12.385a.475.475,0,0,1-.7-.418V6.6a.474.474,0,0,1,.7-.418l4.973,2.681A.475.475,0,0,1,12.506,9.7Z",
    transform: "translate(-1 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.49b12893ef537cb8bc78e15fcca8b02d.svg";
export { ForwardRef as ReactComponent };